// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.system-alerts {
    padding: 24px;
    max-width: 1400px;
    margin: 0 auto;
}

/* Header */
.alerts-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.alerts-header h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #1a1a2e;
}

.alerts-meta {
    display: flex;
    align-items: center;
    gap: 12px;
}

.auto-refresh-badge {
    font-size: 0.75rem;
    color: #888;
    background: #f0f0f0;
    padding: 4px 10px;
    border-radius: 12px;
}

.btn-refresh {
    padding: 6px 16px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
    transition: background 0.2s;
}

.btn-refresh:hover:not(:disabled) {
    background: #f5f5f5;
}

/* Summary cards */
.alerts-summary {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.summary-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 14px 20px;
    border-radius: 10px;
    background: #fff;
    border: 1px solid #e8e8e8;
    min-width: 90px;
}

.summary-total {
    border-left: 4px solid #4a90d9;
}

.summary-critical {
    border-left: 4px solid #e74c3c;
}

.summary-category {
    border-left: 4px solid #f0f0f0;
}

.summary-icon {
    font-size: 1.2rem;
    margin-bottom: 4px;
}

.summary-number {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1a1a2e;
}

.summary-label {
    font-size: 0.75rem;
    color: #888;
    margin-top: 2px;
}

/* Filters */
.alerts-filters {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
    align-items: center;
    flex-wrap: wrap;
}

.filter-select {
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.85rem;
    background: #fff;
    cursor: pointer;
}

.btn-bulk-resolve {
    padding: 8px 16px;
    background: #27ae60;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 600;
    transition: background 0.2s;
}

.btn-bulk-resolve:hover {
    background: #219653;
}

/* Table */
.alerts-table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.alerts-table thead {
    background: #f8f9fa;
}

.alerts-table th {
    padding: 10px 12px;
    text-align: left;
    font-size: 0.8rem;
    font-weight: 600;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e8e8e8;
}

.alerts-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 0.85rem;
    vertical-align: middle;
}

.alert-row {
    cursor: pointer;
    transition: background 0.15s;
}

.alert-row:hover {
    background: #f9f9ff;
}

.alert-row.resolved {
    opacity: 0.55;
}

.alert-row.expanded {
    background: #f5f7ff;
}

/* Severity badges */
.severity-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.78rem;
    font-weight: 600;
    white-space: nowrap;
}

.severity-critical {
    background: #fde8e8;
    color: #c0392b;
}

.severity-error {
    background: #fff3e0;
    color: #e67e22;
}

.severity-warning {
    background: #fff9c4;
    color: #f9a825;
}

/* Category badge */
.category-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 0.78rem;
    background: #f0f0f0;
    white-space: nowrap;
}

/* Title + message */
.alert-title {
    font-weight: 600;
    color: #1a1a2e;
    margin-bottom: 2px;
}

.alert-message {
    font-size: 0.78rem;
    color: #888;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 400px;
}

/* Count badge */
.count-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.78rem;
    font-weight: 600;
    background: #f0f0f0;
    color: #555;
}

.count-badge.high-count {
    background: #ffe0e0;
    color: #c0392b;
}

/* Time */
.time-ago {
    font-size: 0.78rem;
    color: #888;
    white-space: nowrap;
}

/* Action buttons */
.col-actions {
    white-space: nowrap;
}

.btn-resolve-small,
.btn-delete-small {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #ddd;
    background: #fff;
    cursor: pointer;
    font-size: 1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
    transition: all 0.15s;
}

.btn-resolve-small:hover {
    background: #27ae60;
    color: #fff;
    border-color: #27ae60;
}

.btn-delete-small:hover {
    background: #e74c3c;
    color: #fff;
    border-color: #e74c3c;
}

/* Expanded row details */
.alert-details-row td {
    padding: 0 !important;
    border-bottom: 2px solid #e0e0ff;
}

.alert-details {
    padding: 16px 20px;
    background: #fafbfe;
}

.details-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 10px;
    margin-bottom: 12px;
}

.detail-item {
    display: flex;
    flex-direction: column;
}

.detail-item label {
    font-size: 0.72rem;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}

.detail-item span {
    font-size: 0.85rem;
    color: #333;
}

.detail-full {
    margin-top: 10px;
}

.detail-full label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
}

.detail-message,
.detail-stacktrace,
.detail-extra {
    background: #1a1a2e;
    color: #e0e0e0;
    padding: 12px;
    border-radius: 6px;
    font-size: 0.78rem;
    font-family: 'Fira Code', 'Menlo', monospace;
    overflow-x: auto;
    max-height: 250px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0;
}

/* Pagination */
.alerts-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding: 10px 0;
    font-size: 0.85rem;
    color: #888;
}

.pagination-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.pagination-controls button {
    padding: 6px 14px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
    transition: background 0.15s;
}

.pagination-controls button:hover:not(:disabled) {
    background: #f0f0f0;
}

.pagination-controls button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* Loading & empty */
.alerts-loading,
.alerts-empty {
    text-align: center;
    padding: 60px 20px;
    color: #888;
    font-size: 1rem;
}

/* Resolve modal */
.resolve-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.resolve-modal {
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    width: 400px;
    max-width: 90vw;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.resolve-modal h3 {
    margin: 0 0 16px;
    font-size: 1.1rem;
    color: #1a1a2e;
}

.resolve-modal textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.85rem;
    resize: vertical;
    font-family: inherit;
    box-sizing: border-box;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 14px;
}

.btn-cancel {
    padding: 8px 18px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
    cursor: pointer;
    font-size: 0.85rem;
}

.btn-resolve {
    padding: 8px 18px;
    background: #27ae60;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 600;
}

.btn-resolve:hover {
    background: #219653;
}

/* Column widths */
.col-select {
    width: 36px;
}

.col-severity {
    width: 110px;
}

.col-category {
    width: 120px;
}

.col-count {
    width: 70px;
    text-align: center;
}

.col-time {
    width: 100px;
}

.col-actions {
    width: 80px;
    text-align: center;
}

/* Responsive */
@media (max-width: 900px) {
    .alerts-summary {
        flex-direction: row;
        overflow-x: auto;
    }

    .alerts-table {
        display: block;
        overflow-x: auto;
    }

    .alert-message {
        max-width: 200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/SystemAlerts.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;;;IAGI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,SAAS;AACb;;AAEA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA,eAAe;AACf;IACI;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".system-alerts {\n    padding: 24px;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n/* Header */\n.alerts-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.alerts-header h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1a1a2e;\n}\n\n.alerts-meta {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.auto-refresh-badge {\n    font-size: 0.75rem;\n    color: #888;\n    background: #f0f0f0;\n    padding: 4px 10px;\n    border-radius: 12px;\n}\n\n.btn-refresh {\n    padding: 6px 16px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 0.85rem;\n    transition: background 0.2s;\n}\n\n.btn-refresh:hover:not(:disabled) {\n    background: #f5f5f5;\n}\n\n/* Summary cards */\n.alerts-summary {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 20px;\n    flex-wrap: wrap;\n}\n\n.summary-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 14px 20px;\n    border-radius: 10px;\n    background: #fff;\n    border: 1px solid #e8e8e8;\n    min-width: 90px;\n}\n\n.summary-total {\n    border-left: 4px solid #4a90d9;\n}\n\n.summary-critical {\n    border-left: 4px solid #e74c3c;\n}\n\n.summary-category {\n    border-left: 4px solid #f0f0f0;\n}\n\n.summary-icon {\n    font-size: 1.2rem;\n    margin-bottom: 4px;\n}\n\n.summary-number {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: #1a1a2e;\n}\n\n.summary-label {\n    font-size: 0.75rem;\n    color: #888;\n    margin-top: 2px;\n}\n\n/* Filters */\n.alerts-filters {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 16px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.filter-select {\n    padding: 8px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 0.85rem;\n    background: #fff;\n    cursor: pointer;\n}\n\n.btn-bulk-resolve {\n    padding: 8px 16px;\n    background: #27ae60;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    font-weight: 600;\n    transition: background 0.2s;\n}\n\n.btn-bulk-resolve:hover {\n    background: #219653;\n}\n\n/* Table */\n.alerts-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: #fff;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.alerts-table thead {\n    background: #f8f9fa;\n}\n\n.alerts-table th {\n    padding: 10px 12px;\n    text-align: left;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #555;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    border-bottom: 2px solid #e8e8e8;\n}\n\n.alerts-table td {\n    padding: 10px 12px;\n    border-bottom: 1px solid #f0f0f0;\n    font-size: 0.85rem;\n    vertical-align: middle;\n}\n\n.alert-row {\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.alert-row:hover {\n    background: #f9f9ff;\n}\n\n.alert-row.resolved {\n    opacity: 0.55;\n}\n\n.alert-row.expanded {\n    background: #f5f7ff;\n}\n\n/* Severity badges */\n.severity-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 0.78rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.severity-critical {\n    background: #fde8e8;\n    color: #c0392b;\n}\n\n.severity-error {\n    background: #fff3e0;\n    color: #e67e22;\n}\n\n.severity-warning {\n    background: #fff9c4;\n    color: #f9a825;\n}\n\n/* Category badge */\n.category-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 8px;\n    border-radius: 6px;\n    font-size: 0.78rem;\n    background: #f0f0f0;\n    white-space: nowrap;\n}\n\n/* Title + message */\n.alert-title {\n    font-weight: 600;\n    color: #1a1a2e;\n    margin-bottom: 2px;\n}\n\n.alert-message {\n    font-size: 0.78rem;\n    color: #888;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 400px;\n}\n\n/* Count badge */\n.count-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 0.78rem;\n    font-weight: 600;\n    background: #f0f0f0;\n    color: #555;\n}\n\n.count-badge.high-count {\n    background: #ffe0e0;\n    color: #c0392b;\n}\n\n/* Time */\n.time-ago {\n    font-size: 0.78rem;\n    color: #888;\n    white-space: nowrap;\n}\n\n/* Action buttons */\n.col-actions {\n    white-space: nowrap;\n}\n\n.btn-resolve-small,\n.btn-delete-small {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    border: 1px solid #ddd;\n    background: #fff;\n    cursor: pointer;\n    font-size: 1rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 4px;\n    transition: all 0.15s;\n}\n\n.btn-resolve-small:hover {\n    background: #27ae60;\n    color: #fff;\n    border-color: #27ae60;\n}\n\n.btn-delete-small:hover {\n    background: #e74c3c;\n    color: #fff;\n    border-color: #e74c3c;\n}\n\n/* Expanded row details */\n.alert-details-row td {\n    padding: 0 !important;\n    border-bottom: 2px solid #e0e0ff;\n}\n\n.alert-details {\n    padding: 16px 20px;\n    background: #fafbfe;\n}\n\n.details-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 10px;\n    margin-bottom: 12px;\n}\n\n.detail-item {\n    display: flex;\n    flex-direction: column;\n}\n\n.detail-item label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: #888;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 2px;\n}\n\n.detail-item span {\n    font-size: 0.85rem;\n    color: #333;\n}\n\n.detail-full {\n    margin-top: 10px;\n}\n\n.detail-full label {\n    display: block;\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: #888;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 4px;\n}\n\n.detail-message,\n.detail-stacktrace,\n.detail-extra {\n    background: #1a1a2e;\n    color: #e0e0e0;\n    padding: 12px;\n    border-radius: 6px;\n    font-size: 0.78rem;\n    font-family: 'Fira Code', 'Menlo', monospace;\n    overflow-x: auto;\n    max-height: 250px;\n    overflow-y: auto;\n    white-space: pre-wrap;\n    word-break: break-word;\n    margin: 0;\n}\n\n/* Pagination */\n.alerts-pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 16px;\n    padding: 10px 0;\n    font-size: 0.85rem;\n    color: #888;\n}\n\n.pagination-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.pagination-controls button {\n    padding: 6px 14px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 0.85rem;\n    transition: background 0.15s;\n}\n\n.pagination-controls button:hover:not(:disabled) {\n    background: #f0f0f0;\n}\n\n.pagination-controls button:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n/* Loading & empty */\n.alerts-loading,\n.alerts-empty {\n    text-align: center;\n    padding: 60px 20px;\n    color: #888;\n    font-size: 1rem;\n}\n\n/* Resolve modal */\n.resolve-modal-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.resolve-modal {\n    background: #fff;\n    padding: 24px;\n    border-radius: 12px;\n    width: 400px;\n    max-width: 90vw;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.resolve-modal h3 {\n    margin: 0 0 16px;\n    font-size: 1.1rem;\n    color: #1a1a2e;\n}\n\n.resolve-modal textarea {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 0.85rem;\n    resize: vertical;\n    font-family: inherit;\n    box-sizing: border-box;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    margin-top: 14px;\n}\n\n.btn-cancel {\n    padding: 8px 18px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    background: #fff;\n    cursor: pointer;\n    font-size: 0.85rem;\n}\n\n.btn-resolve {\n    padding: 8px 18px;\n    background: #27ae60;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.btn-resolve:hover {\n    background: #219653;\n}\n\n/* Column widths */\n.col-select {\n    width: 36px;\n}\n\n.col-severity {\n    width: 110px;\n}\n\n.col-category {\n    width: 120px;\n}\n\n.col-count {\n    width: 70px;\n    text-align: center;\n}\n\n.col-time {\n    width: 100px;\n}\n\n.col-actions {\n    width: 80px;\n    text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 900px) {\n    .alerts-summary {\n        flex-direction: row;\n        overflow-x: auto;\n    }\n\n    .alerts-table {\n        display: block;\n        overflow-x: auto;\n    }\n\n    .alert-message {\n        max-width: 200px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
